module.exports = __webpack_public_path__ + "img/retail11.a7f5bef4.png";